const statusLabels: Record<string, string> = {
  queued: "排队中",
  running: "授权中",
  success: "成功",
  completed: "已完成",
  partial_failed: "部分失败",
  failed: "失败",
  skipped_insufficient_credits: "积分不足跳过",
  canceled: "已停止",
  canceling: "取消处理中",
  pending: "待处理",
  active: "正常",
  disabled: "已停用",
  synced: "已回填",
};

export function statusLabel(status?: string | null) {
  if (!status) return "未知";
  return statusLabels[status] || status.replaceAll("_", " ");
}

export function statusTone(status?: string | null) {
  if (["completed", "success", "synced", "active"].includes(status || "")) return "success";
  if (["queued", "running", "pending", "canceling", "skipped_insufficient_credits"].includes(status || "")) return "warning";
  if (["failed", "partial_failed", "canceled", "disabled"].includes(status || "")) return "danger";
  return "neutral";
}

export function taskIsDraining(task: { status: string; finished_at?: string | null }) {
  return task.status === "canceled" && !task.finished_at;
}

export function taskIsActive(task: { status: string; finished_at?: string | null }) {
  return ["queued", "running"].includes(task.status) || taskIsDraining(task);
}

export function formatDate(value?: string | null) {
  if (!value) return "尚未发生";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return new Intl.DateTimeFormat("zh-CN", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export function taskProgress(task: {
  total_count: number;
  success_count: number;
  failed_count: number;
  status: string;
}) {
  if (task.status === "completed") return 100;
  if (!task.total_count) return 0;
  return Math.min(100, Math.round(((task.success_count + task.failed_count) / task.total_count) * 100));
}

export function shortNumber(value: number) {
  return new Intl.NumberFormat("zh-CN", { notation: value >= 10000 ? "compact" : "standard" }).format(value);
}
